module.exports = __webpack_public_path__ + "static/img/yearCard.10d89d82.png";